import { useEffect, useState } from 'react';

const useForm = (defaultValues, validate) => {
  const [values, setValues] = useState(defaultValues);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState([]);

  useEffect(() => {
    const validationErrors = validate(values);
    const touchedErrors = Object.keys(validationErrors)
      .filter((key) => touched.includes(key)) // get all touched keys
      .reduce((accumulator, key) => {
        // NOTE: This if-conditional ensures first error occurred displays first
        // * Not necessary if we only do single errors
        // if (!accumulator[key]) {
        accumulator[key] = validationErrors[key];
        // }
        return accumulator;
      }, {});
    setErrors(touchedErrors);
    // NOTE: the validate function is defined *outside* of this component
    // therefore it is safe and unnecessary to include it in the dependency list
    // https://reactjs.org/docs/hooks-faq.html#is-it-safe-to-omit-functions-from-the-list-of-dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [touched, values]);

  const handleBlur = (event) => {
    if (event) event.preventDefault();
    if (!touched.includes(event.target.name)) {
      setTouched([...touched, event.target.name]);
    }
  };

  const handleChange = (event) => {
    event.persist();
    const { name, value } = event.target;
    setValues((values) => ({ ...values, [name]: value }));
  };

  return {
    handleBlur,
    handleChange,
    values,
    errors,
  };
};

export { useForm };
